module.exports = __webpack_public_path__ + "img/山楂2.ae32b57f.png";